var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrahp4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 84,
    viewBox: "0 0 92 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_176_3442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.634 85H24.2962C21.9238 85 20 83.2913 20 81.183V23.817C20 21.7092 21.9232 20 24.2962 20H177.634C180.006 20 181.93 21.7087 181.93 23.817V81.183C181.93 83.2913 180.006 85 177.634 85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.007 30.6809H29.3615C29.2211 30.6809 29.1071 30.5668 29.1071 30.4264C29.1071 30.2859 29.2211 30.1719 29.3615 30.1719H172.007C172.148 30.1719 172.262 30.2859 172.262 30.4264C172.262 30.5668 172.148 30.6809 172.007 30.6809Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.007 41.8576H29.3615C29.2211 41.8576 29.1071 41.7436 29.1071 41.6031C29.1071 41.4626 29.2211 41.3486 29.3615 41.3486H172.007C172.148 41.3486 172.262 41.4626 172.262 41.6031C172.262 41.7441 172.148 41.8576 172.007 41.8576Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.007 53.0344H29.3615C29.2211 53.0344 29.1071 52.9204 29.1071 52.7799C29.1071 52.6394 29.2211 52.5254 29.3615 52.5254H172.007C172.148 52.5254 172.262 52.6394 172.262 52.7799C172.262 52.9204 172.148 53.0344 172.007 53.0344Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.007 64.2102H29.3615C29.2211 64.2102 29.1071 64.0961 29.1071 63.9557C29.1071 63.8152 29.2211 63.7012 29.3615 63.7012H172.007C172.148 63.7012 172.262 63.8152 172.262 63.9557C172.262 64.0961 172.148 64.2102 172.007 64.2102Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.007 75.3859H29.3615C29.2211 75.3859 29.1071 75.2719 29.1071 75.1314C29.1071 74.991 29.2211 74.877 29.3615 74.877H172.007C172.148 74.877 172.262 74.991 172.262 75.1314C172.262 75.2719 172.148 75.3859 172.007 75.3859Z",
    fill: "#E7E5E6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.393 67.3976L113.2 67.2138L87.3725 42.5675L61.4512 55.6661L61.3315 55.5953L35.3741 40.3331L35.6316 39.8943L61.47 55.0864L87.4641 41.9511L113.359 66.6621L139.245 37.0537L165.355 43.7941L165.228 44.2873L139.422 37.6248L113.393 67.3976Z",
    fill: "#FF6D74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9629 39.7988C37.9629 41.1572 36.8615 42.2587 35.503 42.2587C34.1445 42.2587 33.0431 41.1572 33.0431 39.7988C33.0431 38.4403 34.1445 37.3389 35.503 37.3389C36.8615 37.3389 37.9629 38.4403 37.9629 39.7988Z",
    fill: "#FF6D74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9208 55.3769C63.9208 56.7354 62.8193 57.8368 61.4609 57.8368C60.1024 57.8368 59.001 56.7354 59.001 55.3769C59.001 54.0184 60.1024 52.917 61.4609 52.917C62.8193 52.9165 63.9208 54.0179 63.9208 55.3769Z",
    fill: "#FF6D74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8782 42.2597C89.8782 43.6182 88.7768 44.7196 87.4183 44.7196C86.0599 44.7196 84.9584 43.6182 84.9584 42.2597C84.9584 40.9012 86.0599 39.7998 87.4183 39.7998C88.7768 39.7993 89.8782 40.9007 89.8782 42.2597Z",
    fill: "#FF6D74"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5003 73.3697L61.4502 64.8351L35.5635 71.176L35.4424 70.6823L61.4706 64.3063L61.5398 64.3287L87.3364 72.7803L113.36 42.5469L139.453 67.917L165.332 72.1456L165.251 72.6474L139.214 68.3929L139.156 68.3374L113.393 43.289L87.5003 73.3697Z",
    fill: "#D68D2F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9629 70.6142C37.9629 71.9727 36.8615 73.0741 35.503 73.0741C34.1445 73.0741 33.0431 71.9727 33.0431 70.6142C33.0431 69.2557 34.1445 68.1543 35.503 68.1543C36.8615 68.1538 37.9629 69.2552 37.9629 70.6142Z",
    fill: "#D68D2F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9208 64.5703C63.9208 65.9287 62.8193 67.0302 61.4609 67.0302C60.1024 67.0302 59.001 65.9287 59.001 64.5703C59.001 63.2118 60.1024 62.1104 61.4609 62.1104C62.8193 62.1104 63.9208 63.2118 63.9208 64.5703Z",
    fill: "#D68D2F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8782 73.0742C89.8782 74.4326 88.7768 75.5341 87.4183 75.5341C86.0599 75.5341 84.9584 74.4326 84.9584 73.0742C84.9584 71.7157 86.0599 70.6143 87.4183 70.6143C88.7768 70.6143 89.8782 71.7157 89.8782 73.0742Z",
    fill: "#D68D2F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6754 64.6302L35.3303 64.2566L61.4242 40.1447L87.4707 54.87L113.4 51.7347L139.252 59.8458L165.101 30.7031L165.482 31.0406L139.415 60.4301L113.352 52.2538L87.3659 55.3953L87.2931 55.3545L61.497 40.7702L35.6754 64.6302Z",
    fill: "#001748"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9628 64.4433C37.9628 65.8018 36.8614 66.9032 35.5029 66.9032C34.1445 66.9032 33.043 65.8018 33.043 64.4433C33.043 63.0848 34.1445 61.9834 35.5029 61.9834C36.8614 61.9834 37.9628 63.0848 37.9628 64.4433Z",
    fill: "#001748"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9207 40.457C63.9207 41.8154 62.8193 42.9169 61.4608 42.9169C60.1023 42.9169 59.0009 41.8154 59.0009 40.457C59.0009 39.0985 60.1023 37.9971 61.4608 37.9971C62.8193 37.9971 63.9207 39.0985 63.9207 40.457Z",
    fill: "#001748"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8782 55.1328C89.8782 56.4912 88.7767 57.5927 87.4183 57.5927C86.0598 57.5927 84.9584 56.4912 84.9584 55.1328C84.9584 53.7743 86.0598 52.6729 87.4183 52.6729C88.7767 52.6723 89.8782 53.7738 89.8782 55.1328Z",
    fill: "#001748"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_176_3442",
    x: 0,
    y: 0,
    width: 201.93,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_3442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_3442",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrahp4);
export default __webpack_public_path__ + "static/media/grahp4.d7e38b0f859430e1dba3f05fae1a0c34.svg";
export { ForwardRef as ReactComponent };